import React, { useState } from 'react';
import api from '../api';

export default function Signup({ onSuccess, goToLogin }) {
  const [step, setStep] = useState(1); // 1=company, 2=account
  const [form, setForm] = useState({ company_name: '', email: '', password: '', confirm: '', name: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (step === 1) { if (!form.company_name.trim()) return setError('Company name is required'); setError(''); return setStep(2); }
    if (form.password !== form.confirm) return setError('Passwords do not match');
    if (form.password.length < 8) return setError('Password must be at least 8 characters');
    setError(''); setLoading(true);
    try {
      const data = await api.post('/auth/signup', { company_name: form.company_name, email: form.email, password: form.password, name: form.name }).then(r => r.data);
      localStorage.setItem('hrtrack_token', data.token);
      localStorage.setItem('hrtrack_user', JSON.stringify(data.user));
      onSuccess(data);
    } catch (err) {
      setError(err.response?.data?.error || 'Signup failed. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #1e1b4b 0%, #312e81 100%)' }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: '40px 36px', width: 420, boxShadow: '0 20px 60px rgba(0,0,0,.3)' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: '1.8rem', fontWeight: 800, color: '#1e1b4b' }}>HR<span style={{ color: '#4f46e5' }}>Track</span></div>
          <div style={{ color: '#64748b', marginTop: 6, fontSize: '0.9rem' }}>Create your workspace</div>
          {/* Progress */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginTop: 20 }}>
            {[1, 2].map(s => (
              <div key={s} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <div style={{ width: 28, height: 28, borderRadius: '50%', background: step >= s ? '#4f46e5' : '#e2e8f0', color: step >= s ? '#fff' : '#94a3b8', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.8rem', fontWeight: 700 }}>{s}</div>
                {s < 2 && <div style={{ width: 40, height: 2, background: step > s ? '#4f46e5' : '#e2e8f0' }} />}
              </div>
            ))}
          </div>
          <div style={{ color: '#64748b', fontSize: '0.8rem', marginTop: 8 }}>
            {step === 1 ? 'About your company' : 'Create your admin account'}
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          {step === 1 && (
            <div className="form-group">
              <label>Company Name</label>
              <input autoFocus value={form.company_name} onChange={e => set('company_name', e.target.value)} placeholder="Acme Corp" required />
            </div>
          )}

          {step === 2 && (
            <>
              <div className="form-group">
                <label>Your Name</label>
                <input autoFocus value={form.name} onChange={e => set('name', e.target.value)} placeholder="Jane Smith" />
              </div>
              <div className="form-group">
                <label>Work Email</label>
                <input type="email" value={form.email} onChange={e => set('email', e.target.value)} placeholder="jane@acmecorp.com" required />
              </div>
              <div className="form-group">
                <label>Password</label>
                <input type="password" value={form.password} onChange={e => set('password', e.target.value)} placeholder="Min. 8 characters" required />
              </div>
              <div className="form-group">
                <label>Confirm Password</label>
                <input type="password" value={form.confirm} onChange={e => set('confirm', e.target.value)} placeholder="••••••••" required />
              </div>
            </>
          )}

          {error && <div style={{ background: '#fee2e2', color: '#991b1b', padding: '8px 12px', borderRadius: 8, marginBottom: 14, fontSize: '0.875rem' }}>{error}</div>}

          <div style={{ display: 'flex', gap: 10, marginTop: 4 }}>
            {step === 2 && (
              <button type="button" onClick={() => { setStep(1); setError(''); }} className="btn" style={{ flex: 1, justifyContent: 'center', padding: '10px', background: '#f1f5f9', color: '#475569' }}>
                Back
              </button>
            )}
            <button type="submit" className="btn btn-primary" disabled={loading} style={{ flex: 1, justifyContent: 'center', padding: '10px' }}>
              {loading ? 'Creating…' : step === 1 ? 'Continue →' : 'Create Workspace'}
            </button>
          </div>
        </form>

        <p style={{ textAlign: 'center', marginTop: 20, fontSize: '0.875rem', color: '#64748b' }}>
          Already have an account?{' '}
          <button onClick={goToLogin} style={{ background: 'none', border: 'none', color: '#4f46e5', cursor: 'pointer', fontWeight: 600 }}>Sign in</button>
        </p>
        <p style={{ textAlign: 'center', marginTop: 8, fontSize: '0.75rem', color: '#94a3b8' }}>14-day free trial · No credit card required</p>
      </div>
    </div>
  );
}
